import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

function useBookClass() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ planningId }) => {
      const res = await apiClient.post("/api/v1/attendances/", {
        planning: planningId,
      });
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["student", "calendar"] });
      queryClient.invalidateQueries({ queryKey: ["student", "balance"] });
      queryClient.invalidateQueries({ queryKey: ["student", "my-classes"] });
    },
  });
}

export { useBookClass };
